import { X } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import DocumentUploadForm from '../../../../../../components/signup/customers/DocumentUpload';
import { Application } from '../../../../../../types/dbTypes';
import { ApplicationStep } from '../../../../../../types/apiTypes';
import { useOptimisticApplicationStep } from '../../../../../../hooks/useOptimisticApplicationStep';

interface DocumentUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  application_id: string;
  application: Application;
  userId: string;
  // Optional header overrides passed straight through to the generic upload form.
  title?: string;
  description?: string;
}

function DocumentUploadModal({
  isOpen,
  onClose,
  application_id,
  application,
  userId,
  title,
  description,
}: DocumentUploadModalProps) {
  const navigate = useNavigate();
  const optimisticSetApplicationStep = useOptimisticApplicationStep(userId);

  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
    navigate('/dashboard/home');
  };

  const handleSetStep = (step: string) => {
    // When step changes, close the modal and refresh
    if (step !== ApplicationStep.ManualDocumentUpload) {
      // Optimistically reflect the new step so the dashboard updates immediately instead of
      // flashing the stale card while onClose()'s background refetch is in flight.
      optimisticSetApplicationStep(step);
      onClose();
      navigate('/dashboard/home');
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="relative h-full w-full bg-white">
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute right-6 top-6 z-[210] flex h-10 w-10 items-center justify-center rounded-full bg-white text-gray-600 shadow-lg transition-all hover:bg-gray-100 hover:text-gray-900"
          aria-label="Close and return to dashboard"
        >
          <X size={24} weight="bold" />
        </button>

        {/* Document Upload Component */}
        <div className="h-full w-full overflow-y-auto">
          <DocumentUploadForm
            application_id={application_id}
            setStep={handleSetStep}
            application={application}
            title={title}
            description={description}
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentUploadModal;
